import styled from 'styled-components';
export const Backbutton = styled.span`
    display: inline-block;
    background-color: #1b3b5f;
    border-radius: 10px;
    color: #ffffff;
    height: 40px;
    width: 40px;
    cursor: pointer;
    display: grid;
    place-items: center;
`;
export const HeaderContainer = styled.section`
    display: flex;
    justify-content: space-between;
    /* border-bottom: 1px solid rgba(0, 0, 0, 0.04); */
    padding: 0 4rem;
    height: 50px;
    align-items: center;

    @media (max-width: 500px) {
        padding: 0 27px;
    }
    .logo {
        @media (min-width: 992px) {
            width: 10%;
        }
    }
    .menuSection {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 2rem;
        p {
            color: #090a0a;
            font-weight: 400;
            font-size: 18px;
            line-height: 18px;
            @media (max-width: 1023px) {
                font-size: 12px;
            }
        }
        @media (max-width: 500px) {
            gap: 1rem;
        }
        button {
            background: #1b3b5f;
            border: none;
            background: #1b3b5f;
            border-radius: 20px;
            color: white;
            font-style: normal;
            font-weight: 700;
            padding: 10px 24px;
            @media (max-width: 500px) {
                font-size: 10px;
                line-height: 20px;
                padding: 4px 10px;
                border-radius: 10px;
            }
        }
    }
`;
export const HamburgerMenu = styled.div`
    cursor: pointer;
`;

export const HeroSection = styled.section`
    display: flex;
    margin: auto;
    padding: 4rem;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    /* widtqh: 90%; */
    .hero-text {
        width: 55%;
        h1 {
            font-style: normal;
            color: #232938;
            margin-bottom: 1rem;
            @media (max-width: 1023px) {
                font-size: 24px;
            }
            span {
                color: #1b3b5f;
                font-family: 'Neurial-Bold', sans-serif;
            }
        }
        p {
            font-weight: 300;
            color: #050038;
            margin-bottom: 1.5rem;
            @media (max-width: 1023px) {
                font-size: 12px;
            }
        }
        button {
            background: #1b3b5f;
            border-radius: 10px;
            border: none;
            color: white;
            font-weight: 700;
            min-width: 100px;
            padding: 10px;
        }
    }
    @media (max-width: 500px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 4rem 2rem;

        .hero-text {
            margin-bottom: 2rem;
            width: 100%;
            h1 {
                font-size: 33px;
                line-height: 40px;
                letter-spacing: -0.04em;
                @media (max-width: 1023px) {
                    font-size: 24px;
                }
            }
            p {
                font-size: 15px;
                line-height: 20px;
                @media (max-width: 1023px) {
                    font-size: 12px;
                }
            }
            button {
                padding: 10px;
                font-size: 10px;
            }
        }
    }
`;

export const MoreInfoSection = styled.section`
    display: flex;
    position: relative;
    padding: 4rem;
    align-items: center;
    justify-content: center;
    /* width: 90%; */
    gap: 2rem;
    .info-text {
        width: 55%;
        h2 {
            font-style: normal;
            font-weight: 700;
            margin-bottom: 1.5rem;
            color: #1b3b5f;
            @media (max-width: 1023px) {
                font-size: 20px;
            }
        }
        p {
            font-weight: 300;
            color: #050038;
            @media (max-width: 1023px) {
                font-size: 12px;
            }
        }
    }
    @media (max-width: 500px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0rem 2rem;
        .info-text {
            margin-bottom: 2rem;
            width: 100%;
            h2 {
                font-size: 32px;
                line-height: 35px;
                letter-spacing: -0.04em;
                @media (max-width: 1023px) {
                    font-size: 20px;
                }
            }

            p {
                font-size: 15px;
                line-height: 20px;
                @media (max-width: 1023px) {
                    font-size: 12px;
                }
            }
        }
        .floating-img {
            position: absolute;
            top: 10px;
            right: 20%;
        }
    }
`;

export const MissionSection = styled.section`
    display: flex;
    padding: 4rem;
    align-items: center;
    justify-content: center;
    background-color: #f6f6f9;
    overflow: hidden;
    margin-top: 2rem;
    .mission-text {
        h5 {
            font-style: normal;
            font-weight: 300;
            color: #050038;
            margin-bottom: 1rem;
        }
        h2 {
            font-style: normal;
            /* font-weight: 700; */
            letter-spacing: -0.04em;
            color: #1b3b5f;
            margin-bottom: 2rem;
            @media (max-width: 1023px) {
                font-size: 20px;
            }
        }
    }
    .mission-img {
        > img {
            width: 115%;
            height: 100%;
            object-fit: cover;
        }
    }
    @media (max-width: 500px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 3rem 2rem 0;
        .mission-text {
            h5 {
                font-size: 15px;
                line-height: 20px;
            }
            h2 {
                font-size: 32px;
                line-height: 35px;
                @media (max-width: 1023px) {
                    font-size: 20px;
                }
            }
        }
    }
`;

export const WaysSection = styled.section`
    .ways-text {
        h2 {
            font-weight: 700;
            letter-spacing: -0.04em;
            color: #1b3b5f;
            margin-bottom: 2rem;
            @media (max-width: 1023px) {
                font-size: 20px;
            }
        }
        p {
            font-style: normal;
            font-weight: 300;
            color: #050038;
            @media (max-width: 1023px) {
                font-size: 12px;
            }
        }
    }
    @media (max-width: 500px) {
        padding: 3rem 2rem;
        .ways-text {
            h2 {
                font-size: 32px;
                line-height: 35px;
                @media (max-width: 1023px) {
                    font-size: 20px;
                }
            }
            p {
                font-size: 15px;
                line-height: 20px;
                @media (max-width: 1023px) {
                    font-size: 12px;
                }
            }
        }
    }
`;

export const ExtraSection = styled.section`
    background: #1b3b5f;
    color: white;
    position: relative;
    h1 {
        font-style: normal;
        font-weight: 700;
        letter-spacing: -0.04em;
        /* margin-bottom: 3.5rem; */
        @media (max-width: 1023px) {
            font-size: 24px;
        }
    }
    .extra-text {
        margin: 5rem 0 0;
    }
    .dollar {
        position: absolute;
        top: -5%;
        right: 5%;
    }
    @media (max-width: 500px) {
        padding: 3rem 2rem;

        h1 {
            font-size: 32px;
            line-height: 35px;
            @media (max-width: 1023px) {
                font-size: 24px;
            }
        }
        .extra-text {
            h6 {
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 20px;
                margin-bottom: 1rem;
            }
            p {
                font-weight: 300;
                font-size: 15px;
                line-height: 20px;
                color: #ffffff;
                opacity: 0.7;
                @media (max-width: 1023px) {
                    font-size: 12px;
                }
            }
        }
    }
`;

export const TotalSavings = styled.section`
    background-color: #2450a8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    @media (max-width: 500px) {
        height: 150px;
        h4 {
            font-size: 22px;
            background-color: #4e82d388;
            padding: 0.2rem;
        }
        .savings {
            margin-top: 1rem;
            font-size: 0.6rem;
            display: flex;
            align-items: baseline;
            gap: 0.3rem;
            font-weight: 700;
            span {
                background-color: #4e82d388;
                padding: 0.5rem 0.3rem;
                border-radius: 2px;
            }
            i {
                vertical-align: baseline;
            }
        }
    }
`;
export const DesktopHeaderSection = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 3.5rem;
`;
export const NavLinks = styled.nav`
    display: flex;
    gap: 25px;
    align-items: center;
    a {
        color: #0a083b;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-decoration: none;
        :hover {
            text-decoration: underline;
            font-weight: 600;
        }
        button {
            padding: 15px;
            border: 1px solid rgba(0, 0, 0, 0.5);
            border-radius: 20px;
            background-color: unset;
            cursor: pointer;
            font-size: 16px;
            line-height: 19px;
            :hover {
                font-weight: 600;
                border: 2px solid rgba(0, 0, 0, 0.5);
            }
        }
    }
`;
export const TopSection = styled.main`
    background-color: #7fdbd440;
    padding-bottom: 4.5rem;
    width: 100%;
`;
export const DesktopHero = styled.section`
    display: flex;
    max-width: 86%;
    align-items: center;
    margin: 0 auto;
    gap: 2rem;
    @media (max-width: 1024px) {
        width: 90%;
        align-items: flex-start;
    }
    .hero {
        max-width: 100% !important;
        width: 100%;
        @media (max-width: 1254px) {
            width: 50%;
        }
    }
    .hero-text {
        h1 {
            font-weight: 700;
            font-size: 44px;
            line-height: 50px;
            margin-right: 3rem;
            letter-spacing: -0.04em;
            color: #1b3b5f;
            margin-bottom: 2rem;
            @media (max-width: 1225px) {
                font-size: 24px;
                margin-right: 0rem;
                margin-bottom: 1rem;
                line-height: 1;
            }
        }
        p {
            font-style: normal;
            font-family: 'Neurial-light', sans-serif;
            font-weight: 300;
            font-size: 17px;
            line-height: 32px;
            color: #57586e;
            margin-bottom: 2rem;
            @media (max-width: 1023px) {
                font-size: 12px;
            }
        }
    }
    .hero-buttons {
        gap: 27px;
        display: flex;
        a {
            button {
                padding: 12px 25px;
                height: 44px;
                width: 100%;
                border-radius: 16px;
                border: none;
                color: #57586e;
                font-weight: 500;
                font-size: 16px;
                line-height: 16px;
                cursor: pointer;
                border: 1px solid #0000001a;
                transition: all 0.3s ease-in-out;
            }
            :first-of-type > button,
            button:hover {
                background: #1b3b5f;
                color: white;
            }
            :first-of-type > button:hover {
                background: transparent;
                color: #57586e;
            }
        }
    }
`;

export const HowSection = styled.main`
    padding: 5rem;
    @media (max-width: 1023px) {
        padding: 2.5rem 1rem;
    }
    section {
        width: 80%;
        margin: auto;
        h1 {
            font-weight: 700;
            font-size: 44px;
            line-height: 50px;
            letter-spacing: -0.04em;
            color: #1b3b5f;
            @media (max-width: 1023px) {
                font-size: 24px;
                line-height: 1;
            }
        }
        p {
            font-style: normal;
            font-family: 'Neurial-light', sans-serif;
            font-weight: 300;
            font-size: 17px;
            line-height: 32px;
            color: #57586e;
            @media (max-width: 1023px) {
                font-size: 12px;
            }
        }
    }
    .howto-join {
        text-align: center;
        line-height: 32px;
        h1 {
            margin: 0 auto;
            width: 75%;
            margin-bottom: 2rem;
            @media (max-width: 1023px) {
                font-size: 24px;
            }
        }
        p {
            width: 50%;
            margin: auto;
            font-weight: 300;
            margin-bottom: 2.5rem;
            @media (max-width: 1023px) {
                font-size: 12px;
            }
        }
        h5 {
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 32px;
            text-align: center;
            color: #57586e;
            margin-bottom: 2rem;
        }
    }
    .howit-works {
        text-align: center;
        padding: 4rem;
        line-height: 32px;
        > h1 {
            width: 40%;
            margin 0 auto;
            padding: 0.5rem 0 3rem;
            @media (max-width: 1023px) {
                font-size: 24px;
            }
        }
        > div {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 5rem;
            > * {
                width: 45%;
            }
            div {
                width: 45%;
                text-align: left;
                h1 {
                    margin-bottom: 2rem;
                }
            }
            :last-of-type {
                margin-top: -4rem;
            }
        }
    }
`;

export const MissionTop = styled.section`
    background-color: #f6f6f9;
    height: 450px;
    overflow-y: hidden;
    > div {
        width: 65%;
        @media (max-width: 1023px) {
            width: 85%;
        }
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 3rem;
        > div {
            width: 50%;
        }
        img {
            margin-top: 20px;
            @media (max-width: 1023px) {
                margin-top: 3rem;
                width: 60%;
            }
        }
        h1 {
            font-weight: 700;
            font-size: 44px;
            line-height: 50px;
            letter-spacing: -0.04em;
            color: #1b3b5f;
            margin-bottom: 2rem;
            @media (max-width: 1023px) {
                font-size: 24px;
                line-height: 1;
            }
        }
        p {
            font-style: normal;
            font-family: 'Neurial-light', sans-serif;
            font-weight: 300;
            font-size: 17px;
            line-height: 32px;
            color: #57586e;
            margin-bottom: 2rem;
            @media (max-width: 1023px) {
                font-size: 12px;
            }
        }
    }
`;
export const MidMission = styled.section`
    position: relative;
    // height: 450px;
    overflow-y: hidden;
    > div:first-of-type {
        width: 65%;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 3rem;
        > div {
            width: 50%;
        }
        img {
            margin-top: 20px;
            @media (max-width: 1024px) {
                width: 60%;
            }
        }
        h1 {
            font-weight: 700;
            font-size: 44px;
            line-height: 50px;
            letter-spacing: -0.04em;
            color: #1b3b5f;
            margin-bottom: 2rem;
            @media (max-width: 1023px) {
                width: 13rem;
                font-size: 36px;
                line-height: 44px;
            }
        }
        p {
            font-style: normal;
            font-family: 'Neurial-light', sans-serif;
            font-weight: 300;
            font-size: 17px;
            line-height: 32px;
            color: #57586e;
            margin-bottom: 2rem;
            @media (max-width: 1023px) {
                font-size: 12px;
            }
        }
    }
    .float-img {
        position: absolute;
        bottom: 5%;
        right: 10%;
        @media (max-width: 1024px) {
            bottom: 2.5%;
            right: 5%;
            < img {
                width: 20%;
            }
        }
    }
`;
export const MissionBottom = styled.section`
    background: #7fdbd440;
    height: ${(props) => props.height || '380px'};
    > div {
        width: 75%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 3rem;
        > div {
            width: 50%;
            h1 {
                font-weight: 700;
                font-size: 44px;
                line-height: 50px;
                letter-spacing: -0.04em;
                color: #1b3b5f;
                margin-bottom: 2rem;
                @media (max-width: 1023px) {
                    font-size: 24px;
                    line-height: 32px;
                }
            }
            h4 {
                font-weight: 400;
                font-size: 25px;
                line-height: 68px;
                letter-spacing: -0.04em;
                color: #1b3b5f;
                @media (max-width: 1023px) {
                    font-size: 15px;
                    line-height: 30px;
                }
            }
        }
    }
    img {
        margin-top: -9rem;
        @media (max-width: 1023px) {
            margin-top: 0rem;
            width: 50%;
        }
    }
`;
export const StoreFrontContainer = styled.section`
    width: 95%;
    padding-bottom: 1rem;
    padding-top: 1rem;
    margin: auto;
    @media screen and (max-width: 500px) {
        width: 100%;
        padding-bottom: 1rem;
        padding-top: 1rem;
    }
`;
